import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {URLS} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private http: HttpClient) {
  }

  getVehicleApiData(vehicleObj: object, place?: string): object{
    //console.log('prepare data ('+place+')', vehicleObj);
    return vehicleObj;
  }

  getVehicleType() {
    return true;
  }

}
